import React from "react";
import { motion } from "framer-motion";
import { Star } from "lucide-react";

const REVIEWS = [
  { name: "Rosa M.", city: "Como", text: "Persone serie e umane. Mi hanno seguita passo passo senza mai farmi sentire giudicata. Il debito con la finanziaria è stato chiuso a meno della metà." },
  { name: "Davide C.", city: "Varese", text: "Ero scettico, invece nessun anticipo e aggiornamenti costanti. Hanno trattato loro con la banca, io non ho più ricevuto una telefonata." },
  { name: "Antonella S.", city: "Monza", text: "Dopo anni di lettere e minacce di pignoramento, in pochi mesi ho ritrovato la serenità. Consigliati da un'amica, li consiglio a mia volta." },
  { name: "Giorgio B.", city: "Milano", text: "Professionali e trasparenti: mi hanno detto subito cosa era realistico ottenere e cosa no. Il risultato finale è stato persino migliore del previsto." },
  { name: "Luca e Serena P.", city: "Cantù", text: "La casa stava andando all'asta. Oggi viviamo in una nuova abitazione, senza più debiti. Non smetteremo mai di ringraziarli." },
  { name: "Mariapia D.", city: "Lecco", text: "Gentilezza e competenza rare. Rispondono sempre, anche su WhatsApp, e spiegano tutto con parole semplici. Esperienza ottima." },
];

const Stars = () => (
  <div className="flex gap-0.5" aria-label="5 stelle su 5">
    {[0, 1, 2, 3, 4].map(i => <Star key={i} size={15} className="text-[#F59E0B] fill-[#F59E0B]"/>)}
  </div>
);

export const ReviewsSection = () => (
  <section className="py-24 md:py-32 bg-[#FFFFFF]" data-testid="reviews-section">
    <div className="container-editorial">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
        <div>
          <p className="font-mono text-[11px] tracking-[0.25em] uppercase text-[#2d6fc4]">— Recensioni</p>
          <h2 className="font-serif text-5xl md:text-6xl mt-4 leading-[0.95] text-[#2d6fc4]">
            La fiducia<br/><em className="italic">dei nostri clienti.</em>
          </h2>
        </div>
        <div className="flex items-center gap-3" data-testid="reviews-average">
          <p className="font-serif text-5xl text-[#2d6fc4]">4,9<span className="text-2xl text-[#333333]">/5</span></p>
          <div>
            <Stars/>
            <p className="text-xs text-[#333333] mt-1">valutazione media dei clienti</p>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {REVIEWS.map((r, i) => (
          <motion.div
            key={r.name}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: i * 0.06 }}
            className="border border-[#E5E7EB] bg-[#F8FAFC] rounded-lg p-7 flex flex-col"
            data-testid={`review-card-${i}`}
          >
            <Stars/>
            <p className="mt-4 text-[#333333] leading-relaxed text-sm flex-1">“{r.text}”</p>
            <div className="mt-6 border-t border-[#E5E7EB] pt-4 flex items-center justify-between">
              <div>
                <p className="font-medium text-[#2d6fc4] text-sm">{r.name}</p>
                <p className="text-xs text-[#333333]">{r.city}</p>
              </div>
              <p className="font-mono text-[9px] tracking-[0.2em] uppercase text-[#16A34A]">Cliente verificato</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
